import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { ProductManagementService } from 'src/service/product-management.service';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { SellerManagementService } from 'src/service/seller-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BarCodeCategory, FocusInputType, InteractionType, KeyValueSet, KeyValueSetInt, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig, ProductInitialization, SellerInitialization, Wrapper3 } from '../../../service/local.service';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-qrcode-generator',
  templateUrl: './qrcode-generator.component.html',
  styleUrls: ['./qrcode-generator.component.scss']
})
export class QrcodeGeneratorComponent implements OnInit {
  @Input() value: string = '0'; @Input() categoryCode: number = BarCodeCategory.General; @Input() isPopup = false;
  @Input() countryCode: string = ''; @Input() title: string = ''; @Input() isQuantityShow: boolean = false; @Input() businessId = '0'; @Input() productId = '0';
  @Input() isShowButtons = true; @Input() interactionType: InteractionType = InteractionType.None; @Input() displayValue = '';
  lstSectionConfigKeys: string[] = ["barcode"]; @Output() onTitleClicked = new EventEmitter(); @Input() isShowLabelPrint = false;
  printWidth: number = 200; quantity: number = null; isNoQuantity: boolean = true; printContent: string = '';
  IsPrint: boolean = false; FileName: string = ''; barcodeValue: string = '';
  barCodeSize: number = 200; languages: KeyValueSet[]; selectedLanguages: string[] = []; productInitializationWrapper: ProductInitialization; isProduct = false; isBusiness = false; sellerInitializationWrapper: SellerInitialization; isShowMore = false;
  printWidthProduct = 500; productPrice = 0; titles: KeyValueSet[] = []; priceFontSize = 20; titleFontSize = 30;
  barCodeSizeProduct: number = 100; descriptionSource: Wrapper3; descriptions: KeyValueSet[] = [];
  barCodeSizeBusiness: number = 300; printWidthBusiness = 500; titleFontSizeBusiness = 30; descFontSizeBusiness = 20;
  @Input() isGlobalBarcode = true; @Input() tableId: string = '0';

  elementIds: any; @Input() htmlId: string;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;

  isOpenPopupPrintQr = false;

  constructor(private languageManagementService: LanguageManagementService, public localService: LocalService, private profileManagementService: ProfileManagementService, private productManagementService: ProductManagementService, private configurationManagementService: ConfigurationManagementService, private sellerManagementService: SellerManagementService) {

  }

  ngOnInit(): void {
    if (!this.htmlId) {
      this.htmlId = this.localService.getRandomString(5);
    }
    this.elementIds = {
      qr_code_container: 'qr_code_container_' + this.htmlId,
      qr_code_quantity: 'qr_code_quantity_' + this.htmlId,
      qr_code_save: 'qr_code_save_' + this.htmlId,
      qr_code_print: 'qr_code_print_' + this.htmlId
    };

    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (this.localService.getLoginAsCountryCode() == '')
      this.countryCode = this.localService.selected.countryCode;


    this.onSetLastUsedSettings();
    this.onSetBarCode();
    this.isProduct = this.setIsProduct();
    this.isBusiness = this.setIsBusiness();
  }

  onSave(isPrint = false) {
    this.onSetLastUsedSettings();
    this.FileName = 'qrCode_' + this.value + '_' + this.businessId + '_' + this.productId;
    let downloadLink = document.createElement('a');
    downloadLink.setAttribute('download', this.FileName + '.png');
    let canvas = document.getElementById(this.elementIds.qr_code_container).getElementsByTagName('canvas')[0] as HTMLCanvasElement;
    if (isPrint) {
      this.isOpenPopupPrintQr = true;
    } else {
      let dataURL = canvas.toDataURL('image/png');
      let url = dataURL.replace(/^data:image\/png/, 'data:application/octet-stream');
      downloadLink.setAttribute('href', url);
      downloadLink.click();
    }
  }

  onGetBusinessId(): string | undefined {
    let businessId: string | undefined = undefined;
    if (this.businessId && this.businessId != '0')
      businessId = this.businessId;
    else if (this.categoryCode == BarCodeCategory.Business)
      businessId = this.value;
    return businessId;
  }

  onSetLastUsedSettings() {
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != '') {
      this.barCodeSize = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.BarCodeSizeProduct, this.onGetBusinessId());
    if (temp != '') {
      this.barCodeSizeProduct = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TotalWidthProduct, this.onGetBusinessId());
    if (temp != '') {
      this.printWidthProduct = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.PriceSizeProduct, this.onGetBusinessId());
    if (temp != '') {
      this.priceFontSize = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TitleSizeProduct, this.onGetBusinessId());
    if (temp != '') {
      this.titleFontSize = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.SelectedLanguages, this.onGetBusinessId());
    if (temp != '') {
      this.selectedLanguages = temp.split('-');
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.BarCodeSizeBusiness, this.onGetBusinessId());
    if (temp != '') {
      this.barCodeSizeBusiness = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TotalWidthBusiness, this.onGetBusinessId());
    if (temp != '') {
      this.printWidthBusiness = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TitleSizeBusiness, this.onGetBusinessId());
    if (temp != '') {
      this.titleFontSizeBusiness = parseFloat(temp);
    }

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.DescriptionSizeBusiness, this.onGetBusinessId());
    if (temp != '') {
      this.descFontSizeBusiness = parseFloat(temp);
    }
  }

  onSaveLastUsedSettings() {
    if (!this.barCodeSize)
      this.barCodeSize = 200;

    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != this.barCodeSize.toString())
      items.push({ keyType: LastUsedSettingsType.QrPrintSize, value: this.barCodeSize.toString() } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }

  onPrintedBarcode() {
    this.printContent = '';
    this.IsPrint = false;
  }

  onChange(index) {
    switch (index) {
      case 1: {
        this.isNoQuantity = this.quantity == null;
      } break;
      case 2: {
        if (this.isNoQuantity)
          this.quantity = null;
        else {
          this.quantity = 1;
          this.localService.onFocusNextInput(this.elementIds.qr_code_quantity, FocusInputType.TextBox, true);
        }
      } break;
    }
    this.onSetBarCode();
  }

  onSetBarCode() {
    let values: string[] = [];
    if (!this.isGlobalBarcode) {
      values.push(this.localService.localBarCodePrefix);
      values.push(this.categoryCode.toString());
      values.push(this.value);
      values.push(this.quantity ? this.quantity.toString() : '0');
      values.push(this.localService.localBarCodeSufffix);
      this.barcodeValue = values.join(this.localService.barcodeSplitChar);
    } else {
      if (this.categoryCode == BarCodeCategory.None) {
        values.push(this.value);

        this.barcodeValue = (this.categoryCode != BarCodeCategory.None ? environment.url.app : '') + values.join(this.localService.barcodeSplitChar);
      } else if (this.categoryCode == BarCodeCategory.ExploreProducts) {
        values.push('?redirect=');
        values.push('bv');
        values.push(this.localService.getLoginAsCountryCode());
        values.push(this.value);
        values.push(this.tableId);

        this.barcodeValue = environment.url.app + values.join('/');
      } else {
        values.push(this.localService.barCodePrefix);
        values.push(this.localService.getLoginAsCountryCode());
        values.push(this.categoryCode.toString());
        values.push(this.value);
        values.push((!this.quantity ? '0' : this.quantity).toString());
        values.push(this.businessId);
        values.push(this.productId);
        values.push(this.interactionType.toString());

        this.barcodeValue = (this.categoryCode != BarCodeCategory.None ? environment.url.app : '') + values.join(this.localService.barcodeSplitChar);
      }
    }
  }

  setIsProduct(): boolean {
    let isProduct = this.productId && this.productId != '0' ? true : false;
    if (isProduct && !this.productInitializationWrapper) {
      if (this.localService.languages) {
        this.languages = [];
        this.localService.languages.forEach(x => {
          this.languages.push({ key: this.localService.getLanguageCode(x.key), value: this.localService.getEquivalentTitleById(x.key) } as KeyValueSet);
        });
      }

      this.productManagementService.getProductInitialization(this.productId, this.businessId).subscribe(result => {
        this.productInitializationWrapper = result;
        this.onSetSelectedProduct();
        if (this.productInitializationWrapper && this.productInitializationWrapper.product && this.productInitializationWrapper.product.price) {
          this.productInitializationWrapper.product.price.forEach(price => {
            if (price.content.v4) {
              let priceMax = parseFloat(price.content.v4);
              if (this.productPrice < priceMax) {
                this.productPrice = priceMax;
              }
            }
          });
        }
      });
    }
    return isProduct;
  }

  setIsBusiness(): boolean {
    let isBusiness = this.categoryCode == BarCodeCategory.Business;
    if (isBusiness && !this.productInitializationWrapper) {
      if (this.localService.languages) {
        this.languages = [];
        this.localService.languages.forEach(x => {
          this.languages.push({ key: this.localService.getLanguageCode(x.key), value: this.localService.getEquivalentTitleById(x.key) } as KeyValueSet);
        });
      }

      let businessId = this.onGetBusinessId();
      this.sellerManagementService.getSellerInitialization(businessId).subscribe(result => {
        this.sellerInitializationWrapper = result;
        this.onSetSelectedBusiness();
      });

      if (!this.descriptionSource) {
        this.languageManagementService.getLanguagesConfigSectionByKey("barcode", "description").subscribe(result => {
          this.descriptionSource = result;
        });
      }
    }
    return isBusiness;
  }

  onSelectLanguage() {
    if (this.selectedLanguages.length > 3) {
      this.selectedLanguages.splice(this.selectedLanguages.length - 1);
    }
    this.onSaveLastUsedSettingsForLanguage();
    if (this.isProduct)
      this.onSetSelectedProduct();
    if (this.isBusiness)
      this.onSetSelectedBusiness();
  }

  onSetSelectedBusiness() {
    this.titles = [];
    this.selectedLanguages.forEach(languageCode => {
      let languageId = this.localService.getLanguageId(languageCode);
      let item = this.sellerInitializationWrapper && this.sellerInitializationWrapper.business && this.sellerInitializationWrapper.business.languageContentsName ? this.sellerInitializationWrapper.business.languageContentsName.find(x => x.v1 == languageId) : undefined;
      if (item)
        this.titles.push({ key: languageCode, value: item.v3 } as KeyValueSet);
    });

    if (this.titles.length == 0) {
      let languageCode = "en";
      let languageId = this.localService.getLanguageId(languageCode);
      let item = this.sellerInitializationWrapper && this.sellerInitializationWrapper.business && this.sellerInitializationWrapper.business.languageContentsName ? this.sellerInitializationWrapper.business.languageContentsName.find(x => x.v1 == languageId) : undefined;
      if (item)
        this.titles.push({ key: languageCode, value: item.v3 } as KeyValueSet);
    }

    if (this.titles.length == 0) {
      let item = this.sellerInitializationWrapper && this.sellerInitializationWrapper.business && this.sellerInitializationWrapper.business.languageContentsName ? this.sellerInitializationWrapper.business.languageContentsName.filter(x => x.v3 != '')[0] : undefined;
      if (item)
        this.titles.push({ key: this.localService.getLanguageCode(item.v1), value: item.v3 } as KeyValueSet);
    }

    if (this.selectedLanguages.length == 0 && this.titles.length > 0) {
      this.selectedLanguages.push(this.titles[0].key);
    }
  }

  onSetSelectedProduct() {
    this.titles = [];
    this.selectedLanguages.forEach(languageCode => {
      let languageId = this.localService.getLanguageId(languageCode);
      let item = this.productInitializationWrapper && this.productInitializationWrapper.product && this.productInitializationWrapper.product.languageContents ? this.productInitializationWrapper.product.languageContents.find(x => x.v1 == languageId) : undefined;
      if (item)
        this.titles.push({ key: languageCode, value: item.v3 } as KeyValueSet);
    });

    if (this.titles.length == 0) {
      let languageCode = "en";
      let languageId = this.localService.getLanguageId(languageCode);
      let item = this.productInitializationWrapper && this.productInitializationWrapper.product && this.productInitializationWrapper.product.languageContents ? this.productInitializationWrapper.product.languageContents.find(x => x.v1 == languageId) : undefined;
      if (item)
        this.titles.push({ key: languageCode, value: item.v3 } as KeyValueSet);
    }

    if (this.titles.length == 0) {
      let item = this.productInitializationWrapper && this.productInitializationWrapper.product && this.productInitializationWrapper.product.languageContents ? this.productInitializationWrapper.product.languageContents.filter(x => x.v3 != '')[0] : undefined;
      if (item)
        this.titles.push({ key: this.localService.getLanguageCode(item.v1), value: item.v3 } as KeyValueSet);
    }

    if (this.selectedLanguages.length == 0 && this.titles.length > 0) {
      this.selectedLanguages.push(this.titles[0].key);
    }
  }

  onTitleClick() {
    this.onTitleClicked.emit();
  }

  onSaveLastUsedSettingsForLanguage() {
    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.SelectedLanguages, this.onGetBusinessId());
    if (temp != this.selectedLanguages.join("-"))
      items.push({ keyType: LastUsedSettingsType.SelectedLanguages, value: this.selectedLanguages.join("-") } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }

  onSaveLastUsedSettingsForProduct() {
    if (!this.barCodeSizeProduct)
      this.barCodeSizeProduct = 100;
    if (!this.printWidthProduct)
      this.printWidthProduct = 500;
    if (!this.priceFontSize)
      this.priceFontSize = 20;
    if (!this.titleFontSize)
      this.titleFontSize = 30;

    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TotalWidthProduct, this.onGetBusinessId());
    if (temp != this.printWidthProduct.toString())
      items.push({ keyType: LastUsedSettingsType.TotalWidthProduct, value: this.printWidthProduct.toString() } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.PriceSizeProduct, this.onGetBusinessId());
    if (temp != this.priceFontSize.toString())
      items.push({ keyType: LastUsedSettingsType.PriceSizeProduct, value: this.priceFontSize.toString() } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TitleSizeProduct, this.onGetBusinessId());
    if (temp != this.titleFontSize.toString())
      items.push({ keyType: LastUsedSettingsType.TitleSizeProduct, value: this.titleFontSize.toString() } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.BarCodeSizeProduct, this.onGetBusinessId());
    if (temp != this.barCodeSizeProduct.toString())
      items.push({ keyType: LastUsedSettingsType.BarCodeSizeProduct, value: this.barCodeSizeProduct.toString() } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }

  onPrintProduct() {
    if (!this.localService.defaultStyles) {
      this.configurationManagementService.getGlobalConfigurationByCode('receipt_style', this.businessId).subscribe(result => {
        this.localService.defaultStyles = this.localService.replaceAll(result.value, '{{font_path}}', environment.url.app + 'assets/scss/');
        this.onPrintProductFinal();
      });
    } else {
      this.onPrintProductFinal();
    }
  }

  onPrintProductFinal() {
    this.onSetLastUsedSettings();
    let downloadLink = document.createElement('a');
    downloadLink.setAttribute('download', this.FileName + '.png');
    let canvas = document.getElementById(this.elementIds.qr_code_container).getElementsByTagName('canvas')[0] as HTMLCanvasElement;
    let printContent = '<table style="width: ' + (this.barCodeSizeProduct + this.printWidthProduct) + 'px;" class="box">'
      + '<tr>'
      + '<td style="width: ' + (this.barCodeSizeProduct + 10) + 'px;">'
      + '  <div style="margin-bottom: 5px;">'
      + '    <img style="width:' + this.barCodeSizeProduct + 'px;height:' + this.barCodeSizeProduct + 'px;" src="' + canvas.toDataURL() + '"/>'
      + '  </div>'
      + '  <div class="en" style="text-align: center;font-size:' + this.priceFontSize + 'px !important;">'
      + '    ' + this.productPrice.toFixed(2) + ''
      + '  </div>'
      + '</td>'
      + '<td style="width:' + this.printWidthProduct + 'px;">';

    this.titles.forEach(title => {
      printContent += '<div class="' + title.key + '" style="margin-bottom: 10px;">'
        + '    <span style="font-size:' + this.titleFontSize + 'px;">' + title.value + '</span>'
        + '  </div>';
    });

    printContent += '</td>'
      + '</tr>'
      + '</table>';

    this.printContent = '<style>' + this.localService.defaultStyles + '</style>' + printContent;
    this.IsPrint = true;
  }

  onAction(index) {
    switch (index) {
      case 1: {
        this.isShowMore = !this.isShowMore;
      } break;
    }
  }

  onPrintBusiness() {
    if (!this.localService.defaultStyles) {
      this.configurationManagementService.getGlobalConfigurationByCode('receipt_style', this.businessId).subscribe(result => {
        this.localService.defaultStyles = this.localService.replaceAll(result.value, '{{font_path}}', environment.url.app + 'assets/scss/');
        this.onPrintBusinessFinal();
      });
    } else {
      this.onPrintBusinessFinal();
    }
  }


  onSetDescription() {
    this.descriptions = [];
    this.selectedLanguages.forEach(languageCode => {
      let languageId = this.localService.getLanguageId(languageCode);
      let item = this.descriptionSource.languageContents.find(x => x.v1 == languageId);
      if (item)
        this.descriptions.push({ key: languageCode, value: item.v3 } as KeyValueSet);
    });

    if (this.descriptions.length == 0) {
      let languageCode = "en";
      let languageId = this.localService.getLanguageId(languageCode);
      let item = this.descriptionSource.languageContents.find(x => x.v1 == languageId);
      if (item)
        this.descriptions.push({ key: languageCode, value: item.v3 } as KeyValueSet);
    }

    if (this.descriptions.length == 0) {
      let item = this.descriptionSource.languageContents.filter(x => x.v3 != '')[0];
      if (item)
        this.descriptions.push({ key: this.localService.getLanguageCode(item.v1), value: item.v3 } as KeyValueSet);
    }

    if (this.selectedLanguages.length == 0 && this.descriptions.length > 0) {
      this.selectedLanguages.push(this.descriptions[0].key);
    }
  }

  onPrintBusinessFinal() {
    this.onSetLastUsedSettings();
    this.onSetDescription();
    let downloadLink = document.createElement('a');
    downloadLink.setAttribute('download', this.FileName + '.png');
    let canvas = document.getElementById(this.elementIds.qr_code_container).getElementsByTagName('canvas')[0] as HTMLCanvasElement;
    let printContent = '<table style="width: ' + this.printWidthBusiness + 'px;" class="box">'
      + '<tr>'
      + ' <td>';

    this.titles.forEach(title => {
      printContent += '<div class="' + title.key + '" style="margin-top: 10px;text-align: center;">'
        + '    <span style="font-size:' + this.titleFontSizeBusiness + 'px;">' + title.value + '</span>'
        + '  </div>';
    });

    printContent += '  </td>'
      + ' </tr>'
      + ' <tr>'
      + '   <td>'
      + '   <div style="text-align: center;">'
      + '    <img style="width:' + this.barCodeSizeBusiness + 'px;height:' + this.barCodeSizeBusiness + 'px;" src="' + canvas.toDataURL() + '"/>'
      + '   </div>'
      + '  </td>'
      + ' </tr>'
      + ' <tr>'
      + '   <td>';

    this.descriptions.forEach(desc => {
      printContent += '<p class="' + desc.key + '" style="margin-top: 20px;text-align: justify;">'
        + '    <span style="font-size:' + this.descFontSizeBusiness + 'px;">' + desc.value + '</span>'
        + '  </p>';
    });
    printContent += '  </td>'
      + ' </tr>'
      + ' </table>';

    this.printContent = '<style>' + this.localService.defaultStyles + '</style>' + printContent;
    this.IsPrint = true;
  }

  onSaveLastUsedSettingsForBusiness() {
    if (!this.barCodeSizeBusiness)
      this.barCodeSizeBusiness = 300;
    if (!this.printWidthBusiness)
      this.printWidthBusiness = 500;
    if (!this.titleFontSizeBusiness)
      this.titleFontSizeBusiness = 30;
    if (!this.descFontSizeBusiness)
      this.descFontSizeBusiness = 20;

    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TotalWidthBusiness, this.onGetBusinessId());
    if (temp != this.printWidthBusiness.toString())
      items.push({ keyType: LastUsedSettingsType.TotalWidthBusiness, value: this.printWidthBusiness.toString() } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.DescriptionSizeBusiness, this.onGetBusinessId());
    if (temp != this.descFontSizeBusiness.toString())
      items.push({ keyType: LastUsedSettingsType.DescriptionSizeBusiness, value: this.descFontSizeBusiness.toString() } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.TitleSizeBusiness, this.onGetBusinessId());
    if (temp != this.titleFontSizeBusiness.toString())
      items.push({ keyType: LastUsedSettingsType.TitleSizeBusiness, value: this.titleFontSizeBusiness.toString() } as LastUsedKey);

    temp = this.localService.getLastUsedSetting(LastUsedSettingsType.BarCodeSizeBusiness, this.onGetBusinessId());
    if (temp != this.barCodeSizeBusiness.toString())
      items.push({ keyType: LastUsedSettingsType.BarCodeSizeBusiness, value: this.barCodeSizeBusiness.toString() } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }
}
